import {Link} from 'react-router-dom';
import Lottie from 'lottie-react';
import Classes from './NoGifFound.module.scss';
import NoGifLottie from '../../assets/lottie-animations/empty-cart.json';
const NoGifFound = () => {
    return (
        <div className={'d-flex align-items-center justify-content-center my-4 my-md-5'}>
            <div className={Classes.notFoundWarp}>
                <Lottie
                    animationData={NoGifLottie}
                    loop={true}
                    className={Classes.icon}
                />
                <div className="mb-4 mb-lg-5">
                    <p>Oops! No Gifs Found.</p>
                    <Link to={'/create'}>Create Your own GIF</Link>
                </div>
            </div>
        </div>
    );
};

export default NoGifFound;